import { instanceReadStatistics } from 'client/redux/instance/actionCreators';
import { INSTANCE_QRTD_READ_STATISTICS } from 'client/redux/qrtd/constants';

export const instanceQrtdReadStatistics = (id, statistic, query) => dispatch => {
  switch (statistic) {
    default: return dispatch(instanceReadStatistics(INSTANCE_QRTD_READ_STATISTICS, id, statistic, query));
  }
};
